import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useDocs } from 'data/data';

import Button from 'features/portal/Button'

function Document() {
    const { getDoc, isLoading, apiUrl } = useDocs()
    const location = useLocation()

    const [doc, setDoc] = useState(null);
    const [pdfLoading, setPdfLoading] = useState(true);
    const [pdfError, setPdfError] = useState(false);

    let hashId = new URLSearchParams(location.search).get('id') || ''

    let downloadUrl = apiUrl + "/proxy-pdf/" + (doc?.hash_id || '')

    useEffect(() => {
        async function fetchData() {
            let foundDoc = await getDoc(hashId);
            setDoc(foundDoc)
            setPdfLoading(true)
            setPdfError(false)
        }
        if (isLoading === false) {
            fetchData()
        }
    }, [isLoading, hashId, getDoc])

    if (isLoading || doc == null) {
        window.scrollTo({top: 0})
        return <div className="portal"><div className="loading">Loading document…</div></div>
    }

    const getFileName = (filename) => (filename || '').split('/').slice(-1)[0]


    return (
        <div className="doc-page">
            <div className="doc-return-action">
                <Button isPrimary={true} href="/portal">Return to Search Portal</Button>
            </div>
            <div className="doc-title-block">
                <div>
                    <h2>{doc.document || 'Document'}</h2>
                    <p className="mono">{getFileName(doc.file_name)}</p>
                </div>
                <Button isPrimary={true} href={downloadUrl} rel="noreferrer" target="_blank">Download PDF</Button>
            </div>

            <div className="doc-content">
                <div className="doc-detail">
                    <div className="doc-meta">
                        <dl>
                            <dt>Region</dt><dd><span className="tag region">Region {doc.region}</span></dd>
                            <dt>Statute</dt><dd><span className={`badge ${doc.statute ? doc.statute.toLocaleLowerCase() : 'unknown'}`}>{doc.statute || 'Unknown'}</span> </dd>
                            <dt>Document Type</dt><dd><span className={`badge ${doc.document ? doc.document.toLocaleLowerCase() : 'unknown'}`}>{doc.document}</span>{' '}{/* description */}
                                {doc.document === 'INFOREQ' ? ' — Information Request (Section 114 / 308)' : doc.document === 'ENF' ? ' — Enforcement Action' : ''}
                            </dd>
                            <dt>Company / Entity</dt><dd><span className="tag company">{doc.facility || doc.company || 'FOIA'}</span></dd>
                            <dt>Year</dt>
                            <dd>
                                <span className="tag year">{doc.year || 'N/A'}</span>
                                &nbsp;
                            </dd>
                            <dt>File Size</dt><dd><span className="tag filesize">{doc.size || doc.file_size}</span></dd>
                            
                        </dl>
                        <div className="doc-text">
                        <pre>{doc.summary || doc.doc_summary || ''}</pre>
                    </div>
                    </div>
                </div>

                <iframe src={downloadUrl} title="Document preview" />
            </div>
        </div>
    )
}

export default Document;